






























import { Component, Vue, Prop } from "vue-property-decorator";
import SingleImageCard from "@/components/SingleImageCard.vue";
import TitleTextColumnCard from "@/components/TitleTextColumnCard.vue";
import { pageDataType } from "../types";
import { HOST } from "../global";
@Component({
  name: "MissionCard",
  components: {
    single_image: SingleImageCard,
    title_text_column: TitleTextColumnCard,
  },
})
export default class MissionCard extends Vue {
  @Prop() readonly compData!: any;
  public HOST: string = HOST;
}
